/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import Selected from 'material-ui-icons/RadioButtonChecked';
import Unselected from 'material-ui-icons/RadioButtonUnchecked';

export default class SelectableIcon extends React.Component {
	render() {
		if (this.props.selected) {
			return (
				<Selected
					size={24}
					style={{
						color: '#06D3E5',
					}}
				/>
			);
		} else {
			return <Unselected size={24} color='disabled' />;
		}
	}
}



// WEBPACK FOOTER //
// ./src/level/SelectableIcon.js